"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genericReducer = genericReducer;
exports.replacementReducer = replacementReducer;
exports.deepMergeReducer = deepMergeReducer;
exports.sliceReducer = sliceReducer;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Updates the state from the action. The action is based on a more permissive
 * model of Flux Standard Actions. We look specifically for the keys 
 * "type", "payload", "error", and "meta". 
 * - The "type" key is not incorporated into the new state
 * - The "payload" key is destructured into the state slice.
 * - The "error" key is transferred to the new state under the same key
 * - The "meta" key is not incorporated in the new state, as its
 *   purpose is to advise the reducer
 * - Any other keys will be transferred to state, as the same key
 * 
 * This was designed for use with ./sagas.js, where you can just use
 * the syntax:
 *
 * yield put({type: "<key>/SOME_ACTION_TYPE", ...payload })
 *
 * 
 * @param {Object} state The previous state
 * @param {Object} action The action. 
 * @param {String} action.type The action type
 */
function genericReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  // eslint-disable-next-line no-unused-vars
  var type = action.type,
      payload = action.payload,
      meta = action.meta,
      other = _objectWithoutProperties(action, ["type", "payload", "meta"]);

  return _objectSpread({}, state, {}, payload, {}, other);
}
/**
 * Replaces the current state with the newly provided action's state
 * information. The action is interpreted in the same way as 
 * genericReducer
 * @param {object} state This state will actually be discarded. The
 *   parameter is specified only for consistency with other reducer
 *   functions
 * @param {*} action The action 
 */


function replacementReducer(state, action) {
  // eslint-disable-next-line no-unused-vars
  var type = action.type,
      payload = action.payload,
      meta = action.meta,
      other = _objectWithoutProperties(action, ["type", "payload", "meta"]);

  return _objectSpread({}, payload, {}, other);
}
/**
 * Deeply merges the action's state with the current state
 * @param {Object} state The previous state
 * @param {Object} action The action. 
 */


function deepMergeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  // eslint-disable-next-line no-unused-vars
  var type = action.type,
      _action$payload = action.payload,
      payload = _action$payload === void 0 ? {} : _action$payload,
      meta = action.meta,
      other = _objectWithoutProperties(action, ["type", "payload", "meta"]);

  return _deepmerge["default"].all([state, payload, other]);
}
/**
 * Builds a reducer that handles a given key slice of the overall
 * state. For example, given a key of `actionCategory1`, the 
 * resulting reducer will only handle actions where:
 *   - action.type === "actionCategory1", or
 *   - action.type starts with "actionCategory1/", such as
 *       action{ type: "actionCategory1/foo"}
 * 
 * If no reducer is supplied, the default is the genericReducer
 *
 * @param {String} key 
 * @param {Function} reducer
 */


function sliceReducer(key) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : genericReducer;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var type = action.type;

    if (type !== undefined && (type === key || type.startsWith("".concat(key, "/")))) {
      return reducer(state, action);
    } else {
      return state;
    }
  };
}